import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ChatHeader } from './ChatHeader';
import { Correspondence } from './Correspondence';
import { ChatInput } from './ChatInput';
import * as styles from './Chat.module.css';
export const Chat = () => {
    const [replayMessage, setReplayMessage] = useState();
    return (_jsxs("div", { className: styles.chatBox, children: [_jsx(ChatHeader, {}), _jsx(Correspondence, { setReplayMessage: setReplayMessage }), _jsx(ChatInput, { replayMessage: replayMessage, removeReplay: () => setReplayMessage(undefined) })] }));
};
